let currentDraggedVariable = null;
export function setDraggedVariable(v) {
    currentDraggedVariable = v;
}
export function getDraggedVariable() {
    return currentDraggedVariable;
}
